module.exports = __webpack_public_path__ + "img/04.7a8413b7.jpg";